import type { HealthMetricKey } from './types';

export const TEST_ID = 'dronesGridCard';

export const RING_METRIC_KEY_BY_PART_TYPE: Record<string, HealthMetricKey> = {
    MOTOR: 'MOTORS',
    PROPELLER_SET: 'PROPS',
    PUMP: 'PUMPS'
};
